import { render, staticRenderFns } from "./MenuPopover.vue?vue&type=template&id=5c51857b&scoped=true&"
import script from "./MenuPopover.vue?vue&type=script&lang=js&"
export * from "./MenuPopover.vue?vue&type=script&lang=js&"
import style0 from "./MenuPopover.vue?vue&type=style&index=0&id=5c51857b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c51857b",
  null
  
)

export default component.exports